<template>
    <div>
        <el-button-group class="operations-button-group">
            <el-button
                v-if="showConfirmButton"
                type="success"
                icon="el-icon-check"
                @click="confirmInspection"
            ></el-button>
            <el-button
                v-if="showRescheduleButton"
                type="primary"
                @click="displayRescheduleDialog = true;"
            >
                <i class="ti-calendar"></i>
            </el-button>
            <el-button
                v-if="showCancelButton"
                type="danger"
                icon="el-icon-delete"
                @click="cancelInspection"
            ></el-button>
            <el-button
                type="primary"
                @click="displayCommentsDialog = true"
            >
                <i class="ti-comment-alt"></i>
            </el-button>
            <!-- <el-button
                v-if="showArchiveButton"
                type="info"
                @click="archiveInspection"
            >
                <i class="ti-archive"></i>
            </el-button> -->
        </el-button-group>
        <el-badge v-if="existingComments.length !== 0" :value="existingComments.length" class="badge-comment"></el-badge>
        <el-dialog
            title="Reprogrammer une requête d'inspection"
            :visible.sync="displayRescheduleDialog"
            :append-to-body="true"
        >
            <span>
                Veuillez sélectionner une date d'inspection.
            </span>
            <el-form
                ref='rescheduleDateForm'
                :model="form"
                :rules="rules"
            >
                <el-form-item prop="rescheduledDate">
                    <el-date-picker
                        v-model="form.rescheduledDate"
                        type="daterange"
                        range-separator="à"
                        start-placeholder="Date de début"
                        format="dd/MM/yyyy"
                        end-placeholder="Date de fin">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="displayRescheduleDialog = false">Annuler</el-button>
                <el-button type="primary" @click="rescheduleInspection()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title='Commentaires'
            :visible.sync="displayCommentsDialog"
            :append-to-body="true"
        >
            <span>
                <p v-if="existingComments.length == 0">Pas de commentaires.</p>
                <comments v-else :comments="existingComments"></comments>
                <br/>
                <p>Ajouter un commentaire :</p>
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Veuillez écrire votre commentaire"
                    v-model="comment">
                </el-input>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="displayCommentsDialog = false">Fermer</el-button>
                <el-button
                    type="primary"
                    :disabled="noCommentWritten"
                    @click="addComments()"
                >
                    Ajouter
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Comments from './comments.vue';
import moment from 'moment';
import {EventBus} from '@/event-bus.js';
import { mapGetters } from 'vuex';

export default {

    components: {
        Comments,
    },

    props: {
        inspectionRequest: {
            type: Object,
            required: true,
        },

        userIsClient: {
            type: Boolean,
            required: true,
        }
    },

    data () {
        return {
            displayRescheduleDialog: false,
            displayCommentsDialog: false,
            form: {
                rescheduledDate: '',
            },
            rules: {
                rescheduledDate: [
                    {required: true, message:'Veuillez sélectionner une date', trigger: 'change'}
                ],
            },
            comment: '',
        };
    },

    computed: {
        ...mapGetters([
            'getSelectedFleet',
        ]),
        noCommentWritten() {
            return this.comment.length == 0;
        },

        existingComments() {
            return this.inspectionRequest.comment.hasOwnProperty('comments') ?
                this.inspectionRequest.comment.comments : [];
        },
        showConfirmButton() {
            let inspectionNotAnswered = !this.inspectionRequest.vehicle_available && !this.inspectionRequest.client_has_answered;
            let rescheduledByClient = this.inspectionRequest.client_has_answered
                && this.inspectionRequest.rescheduled
                && this.inspectionRequest.vehicle_available === false
                && this.inspectionRequest.vehicle_out_of_fleet === false;
            return this.userIsClient && (inspectionNotAnswered || rescheduledByClient || this.inspectionRequest.vehicle_out_of_fleet);
        },

        showRescheduleButton() {
            return !this.inspectionRequest.client_has_answered || this.userIsClient;
        },

        showCancelButton() {
            return this.userIsClient && !this.inspectionRequest.vehicle_out_of_fleet;
        },
    },

    methods: {
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },

        confirmInspection() {
            this.$store.dispatch('patchItem', {
                item: {
                    url: this.inspectionRequest.url,
                    vehicle_available: true,
                    vehicle_out_of_fleet: false,
                    client_has_answered: true,
                },
                model: 'inspectionRequests',
            }).then(() => {
                this.$store.dispatch('createItem', {
                    item: {
                        name: 'CONFIRMÉE',
                        inspection_request_uid: this.inspectionRequest.uid,
                        can_admin_groups: this.inspectionRequest.can_admin_groups,
                        client_group_uid: this.getSelectedFleet,
                        public: false,
                    },
                    model: 'inspectionRequestLogs',
                    url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                });
                this.$notify({
                    type: 'success',
                    title: 'Confirmation réussie!',
                    message: "L'inspection a été confirmée.",
                });
                EventBus.$emit('refreshTable');
            }).catch((error) => {
                console.error(error);
                this.$notify({
                    type: 'error',
                    title: 'Échec de confirmation',
                    message: "Il y a eu une erreur lors de la confirmation de l'inspection. Veuillez réessayer ou bien contacter un administrateur pour plus d'information."
                });
            });
        },
        rescheduleInspection() {
            this.$refs['rescheduleDateForm'].validate((valid) => {
                if(valid) {
                    this.$store.dispatch('patchItem', {
                        item: {
                            url: this.inspectionRequest.url,
                            scheduled_date_start: this.formatDate(this.form.rescheduledDate[0]),
                            scheduled_date_end: this.formatDate(this.form.rescheduledDate[1]),
                            client_has_answered: this.userIsClient,
                            vehicle_out_of_fleet: false,
                            vehicle_available: false,
                            rescheduled: true
                        },
                        model: 'inspectionRequests',
                    }).then(() => {
                        this.$store.dispatch('createItem', {
                            item: {
                                name: `REPROGRAMMÉ - Date précédentes: ${this.inspectionRequest.scheduled_date_start} - ${this.inspectionRequest.scheduled_date_end}`,
                                inspection_request_uid: this.inspectionRequest.uid,
                                can_admin_groups: this.inspectionRequest.can_admin_groups,
                                client_group_uid: this.getSelectedFleet,
                                public: false,
                            },
                            model: 'inspectionRequestLogs',
                            url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                        });
                        this.$notify({
                            type: 'success',
                            title: 'Succès',
                            message: "L'inspection a été reprogrammée !"
                        });
                        this.rescheduledDate = '';
                        this.displayRescheduleDialog = false;
                        EventBus.$emit('refreshTable');
                    }).catch((error) => {
                        console.error(error);
                        this.$notify({
                            type: 'error',
                            title: 'Échec de reprogrammation',
                            message: "Il y a eu une erreur lors de la reprogrammation de l'inspection. Veuillez réessayer ou bien contacter un administrateur pour plus d'information."
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        cancelInspection() {
            this.$confirm(`Le véhicule ${this.inspectionRequest.plate} ne fait plus partie de la base. Voulez-vous annuler l'inspection`, 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                type: 'warning'
            }).then( () => {
                this.$store.dispatch('patchItem', {
                    item: {
                        url: this.inspectionRequest.url,
                        vehicle_out_of_fleet: true,
                        client_has_answered: true,
                        vehicle_available: false,
                    },
                    model: 'inspectionRequests',
                }).then(() => {
                    this.$store.dispatch('createItem', {
                        item: {
                            name: 'ANNULÉE',
                            inspection_request_uid: this.inspectionRequest.uid,
                            can_admin_groups: this.inspectionRequest.can_admin_groups,
                            client_group_uid: this.getSelectedFleet,
                            public: false,
                        },
                        model: 'inspectionRequestLogs',
                        url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                    });
                    this.$notify({
                        type: 'success',
                        title: 'Succès',
                        message: "L'inspection a été annulée !"
                    });
                    EventBus.$emit('refreshTable');
                }).catch((error) => {
                    console.error(error);
                    this.$notify({
                        type: 'error',
                        title: "Échec de l'annulation",
                        message: "Il y a eu une erreur lors de l'annulation de l'inspection. Veuillez réessayer ou bien contacter un administrateur pour plus d'information"
                    });
                });
            });
        },
        addComments() {
            let existingComments = this.existingComments;
            let comment = {};
            comment.date = moment().format('DD/MM/YYYY HH:mm');
            comment.author = this.$store.getters.currentUser.verbose_name;
            comment.content = this.comment;
            existingComments.push(comment);
            this.$store.dispatch('patchItem', {
                item: {
                    url: this.inspectionRequest.url,
                    comment: {'comments': existingComments},
                },
                model: 'inspectionRequests',
            }).then(() => {
                this.$store.dispatch('createItem', {
                    item: {
                        name: 'COMMENTÉ',
                        inspection_request_uid: this.inspectionRequest.uid,
                        can_admin_groups: this.inspectionRequest.can_admin_groups,
                        client_group_uid: this.getSelectedFleet,
                        public: false,
                    },
                    model: 'inspectionRequestLogs',
                    url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                });
                this.$notify({
                    type: 'success',
                    title: 'Succès',
                    message: 'Commentaire ajouté !'
                });
                this.comment = '';
            }).catch((error) => {
                console.error(error);
                this.$notify({
                    type: 'error',
                    title: "Échec lors de l'ajout du commentaire",
                    message: "Il y a eu une erreur lors de l'ajout du commentaire. Veuillez réessayer ou bien contacter un administrateur pour plus d'information"
                });
            });
        },

        // archiveInspection() {
        //     this.$confirm(`The vehicle ${this.inspectionRequest.plate} is no longer a part of the vehicle fleet. Do you want to archive this inspection request?`, 'Warning', {
        //         confirmButtonText: 'Yes',
        //         cancelButtonText: 'No',
        //         type: 'warning'
        //     }).then( () => {
        //         this.$store.dispatch('patchItem', {
        //             item: {
        //                 url: this.inspectionRequest.url,
        //                 archived: true,
        //             },
        //             model: 'inspectionRequests',
        //         }).then(() => {
        //             this.$notify({
        //                 type: 'success',
        //                 title: 'Success',
        //                 message: 'Inspection request archived!'
        //             });
                    // this.$emit('refreshTable');
        //         }).catch((error) => {
        //             console.error(error);
        //             this.$notify({
        //                 type: 'error',
        //                 title: 'Inspection requests modification failed!',
        //                 message: 'There has been an error during the modification of the inspection. Please try again or contact an administrator for more information.'
        //             });
        //         });
        //     });
        // },
    }
};
</script>

<style lang="scss">

.operations-button-group {
    height: 40px;

    .badge-comment {

    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/operations.vue